import axios from 'axios';

/**
 * get searchAccountLog 取得アカンウトログ情報リスト
 */
export const getAccountLoginLogList = data =>
    axios.$callAPI(() => axios.get('logs/searchAccountLog', { params: data }));

/**
 * get searchOperationLog 取得操作ログ情報リスト
 */
export const getOperationLogList = data => axios.$callAPI(() => axios.get('logs/searchOperationLog', { params: data }));
